(function(){
  'use strict';

  var productsWithoutExactChart = {
    'boxy-cinched-hem-hoodie': 'This style has a relaxed body and a cinched hem. Choose your usual size for the intended shape. Size down for less volume or size up for a fuller silhouette.',
    'wide-leg-drawstring-sweatpants': 'Choose using both waist and fullest hip measurement. This style needs enough room through the seat. Customers with fuller hips, or anyone between sizes, should choose the larger size.',
    'snow-wash-hand-frayed-heavyweight-hoodie-1': 'This is an oversized style with dropped shoulders. Choose your usual size for the intended fit. Size down for a cleaner shape or size up for extra volume.',
    'snow-wash-heavyweight-jogged-sweatpants-1': 'Choose using both waist and fullest hip measurement. Customers with fuller hips or anyone between sizes should choose the larger size for comfort through the seat.'
  };

  function productHandle(){
    var match = window.location.pathname.match(/\/products\/([^/?#]+)/);
    return match ? match[1] : '';
  }

  function addFitFallback(){
    var handle = productHandle();
    var message = productsWithoutExactChart[handle];
    var button = document.querySelector('[data-bc-open-size-guide]');
    if(!message || !button) return;

    var panel = document.createElement('div');
    panel.className = 'brwn-product-fit-note';
    panel.innerHTML = '<strong>Fit guidance</strong><p>' + message + '</p><p><a href="/pages/size-guide">Open the full size and fit guide</a></p>';
    button.replaceWith(panel);
  }

  function requireSizeSelection(){
    var addButton = document.getElementById('bc-pdp-atc');
    var sizeButtons = Array.prototype.slice.call(document.querySelectorAll('.bc-product-details__size-pill'));
    if(!addButton || !sizeButtons.length) return;

    sizeButtons.forEach(function(button){
      button.classList.remove('bc-product-details__size-pill--selected');
      button.setAttribute('aria-pressed','false');
    });

    addButton.disabled = true;
    addButton.textContent = 'SELECT A SIZE';

    sizeButtons.forEach(function(button){
      button.addEventListener('click', function(){
        if(button.dataset.available === 'false') return;
        addButton.disabled = false;
        addButton.textContent = 'ADD TO CART';
      });
    });
  }

  function addAssurance(){
    var addButton = document.getElementById('bc-pdp-atc');
    if(!addButton || document.querySelector('.brwn-pdp-assurance')) return;

    var box = document.createElement('div');
    box.className = 'brwn-pdp-assurance';
    box.innerHTML = '<a class="brwn-pdp-assurance__row" href="/pages/shipping"><span class="brwn-pdp-assurance__mark">✓</span><span><strong>Made to order</strong><span>Most orders dispatch within 1 to 2 business days.</span></span></a><a class="brwn-pdp-assurance__row" href="/pages/returns"><span class="brwn-pdp-assurance__mark">↺</span><span><strong>Easy 14 day returns</strong><span>Available on standard size garments under our returns policy.</span></span></a><a class="brwn-pdp-assurance__row" href="/pages/size-guide"><span class="brwn-pdp-assurance__mark">↔</span><span><strong>Fit support</strong><span>Use the product calculator or contact us before ordering.</span></span></a>';
    addButton.insertAdjacentElement('afterend', box);
  }

  function initialise(){
    if(!document.body.classList.contains('template-product')) return;
    requireSizeSelection();
    addFitFallback();
    addAssurance();
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initialise);
  } else {
    initialise();
  }
})();